/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CameraType = {
    Dahua: 'Dahua',
    Milesight: 'Milesight',
    VZenith: 'VZenith'
} as const;
export type CameraType = typeof CameraType[keyof typeof CameraType];

